import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const JobsAppliedChart = ({ jobs_applicants_statistics }) => {
    const { chart_data, stats } = jobs_applicants_statistics || {};
    
    const options = {
        animationEnabled: true,
        title: {
            text: "Job Applications (Last 6 Months)",
            fontSize: 16,
            fontFamily: "Arial",
            fontWeight: "normal",
            fontColor: "#EE5E1B",
        },
        axisY: {
            title: "Number of Applications",
            titleFontSize: 12,
        },
        axisX: {
            labelFontSize: 10,
        },
        toolTip: {
            shared: true,
            reversed: true
        },
        legend: {
            verticalAlign: "center",
            horizontalAlign: "right",
            reversed: true,
            cursor: "pointer",
        },
        data: [
            {
                type: "stackedColumn",
                name: "Approved",
                showInLegend: true,
                color: "#4CAF50",
                dataPoints: Object.keys(chart_data || {}).map(month => ({
                    y: parseInt(stats?.approved) || 0,
                    label: month
                }))
            },
            {
                type: "stackedColumn",
                name: "Pending",
                showInLegend: true,
                color: "#FFC107",
                dataPoints: Object.keys(chart_data || {}).map(month => ({
                    y: parseInt(stats?.pending) || 0,
                    label: month
                }))
            },
            {
                type: "stackedColumn",
                name: "Rejected",
                showInLegend: true,
                color: "#F44336",
                dataPoints: Object.keys(chart_data || {}).map(month => ({
                    y: parseInt(stats?.rejected) || 0,
                    label: month
                }))
            },
            {
                type: "spline",
                name: "Total Applications",
                showInLegend: true,
                color: "#2196F3",
                markerSize: 0,
                dataPoints: Object.keys(chart_data || {}).map(month => ({
                    y: chart_data?.[month] || 0,
                    label: month
                }))
            }
        ]
    };

    return (
        <div className="h-full">
            <CanvasJSChart options={options} 
                containerProps={{
                    height: '300px',
                    width: '100%'
                }} 
            />
            <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="bg-blue-50 p-3 rounded">
                    <h3 className="text-blue-800 font-medium">Total Applications</h3>
                    <p className="text-2xl">{stats?.total_applications || 0}</p>
                </div>
                <div className="bg-green-50 p-3 rounded">
                    <h3 className="text-green-800 font-medium">Users Took Tests</h3>
                    <p className="text-2xl">{stats?.users_with_tests || 0}</p>
                </div>
            </div>
        </div>
    );
}